import { createActions } from "redux-actions";

const {
  searchPeople,
  searchPeopleSuccess,
  searchPeopleFailure,
  clearSearch
} = createActions(
  "SEARCH_PEOPLE",
  "SEARCH_PEOPLE_SUCCESS",
  "SEARCH_PEOPLE_FAILURE",
  "CLEAR_SEARCH"
);

export {
  searchPeople,
  searchPeopleSuccess,
  searchPeopleFailure,
  clearSearch
};
